import { useNavigate } from "react-router-dom";

import WorkspaceHomePage from "./home/page";

export const BRAND = "#FF6B35";

export type OrderType = "car" | "hotel" | "tour" | "guide";

export default function WorkspacePage() {
  // 工作台主页面直接渲染首页（原 subExpertPackage/home/index.vue）
  return <WorkspaceHomePage />;
}
